import React, { useEffect, useState } from 'react';
import { NumberInput } from '../../../../../shared/components/ui/atoms';
import { DownArrowSVG } from '../constants';

const ConfirmationSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <circle cx="9" cy="9" r="8" fill="#F5FAF7" stroke="#587E5B" />
    <path d="M13.8889 6L7.77778 12.1111L5 9.33333" stroke="#587E5B" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

interface AdjustLoanAmountProps {
  loanBalance: number;
  setLoanBalance: (value: number) => void;
}

export const AdjustLoanAmount = ({ loanBalance, setLoanBalance }: AdjustLoanAmountProps) => {
  const [isSelected, setIsSelected] = useState(false)
  const [innerLoanBalance, setInnerLoanBalance] = useState(loanBalance)

  useEffect(() => {
    setInnerLoanBalance(loanBalance)
  }, [loanBalance])

  const toggleIsSelected = () => {
    if (isSelected) {
      setLoanBalance(innerLoanBalance)
    }
    setIsSelected(!isSelected)
  }

  return (
    <div className='adjust-loan-amount'>
      {
        !isSelected ?
          <div className='label' onClick={toggleIsSelected}>
            Adjust Loan Amount
            <div className='arrow-container'>
              <DownArrowSVG/>
            </div>
          </div>
          :
          <div>
            <NumberInput 
              label="Loan Amount"
              value={innerLoanBalance}
              setValue={setInnerLoanBalance}
            />
              <div className='svg-container' onClick={toggleIsSelected}><ConfirmationSVG /></div>
          </div>
      }
    </div>
  )
}

